export default __webpack_public_path__ + "static/icon-handshake-shield-c91915365d5731117907b628da88d544.jpg";